module.exports = __webpack_public_path__ + "static/media/01.4fedcb75.png";